import { Component } from "react"
import PropTypes from "prop-types"

import fetchWorksWithIcons from "./works_with_icon_fetcher"

class CategoriesSelectorContent extends Component {
  state = {
    worksWithIcons: [],
  }

  componentDidMount() {
    if (this.props.categoryName !== "All") this.updateWorksWithIcons()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categoryName !== this.props.categoryName)
      this.updateWorksWithIcons()
  }

  updateWorksWithIcons() {
    fetchWorksWithIcons(
      this.props.serviceModuleName,
      this.props.categoryName,
      this.props.currentMetricDate
    ).then(worksWithIcons => this.setState({ worksWithIcons }))
  }

  render() {
    const { worksWithIcons } = this.state

    if (worksWithIcons.length) {
      return (
        <>
          {worksWithIcons
            .slice(0, 7)
            .map(
              (icon, i) =>
                icon && <img key={i} src={icon} width={40} height={40} />
            )
            .concat(
              worksWithIcons.length > 7 && (
                <span key={8}>+{worksWithIcons.length - 7} more</span>
              )
            )}
        </>
      )
    } else {
      return (
        <div>
          Choose a category to see how {this.props.serviceName} is connecting
          with different service categories.
        </div>
      )
    }
  }
}

CategoriesSelectorContent.propTypes = {
  serviceName: PropTypes.string,
  serviceModuleName: PropTypes.string,
  categoryName: PropTypes.string,
  currentMetricDate: PropTypes.string.isRequired,
}

export default CategoriesSelectorContent
